export const fleet = {
  fleetName: "Fleet Name",
  fleetManager: "Fleet Manager",
  totalVehicles: "Total Vehicles",
  totalDrivers: "Total Drivers",
  description: "Description",
  firstDayOfWeek: "First Day of Week",
  workingDays: "Working Days",
  workingHours: "Working Hours",
  location: "Location",
  vehicleList: "Vehicle List",
  unassignedVehicles: "Unassigned Vehicles",
  userList: "User List",
  inspection: "Inspection",
  startDate: "Start Date",
  repeatInterval: "Inspection Cycle",
  repeatIntervalDays: "Inspection Cycle (Days)",
  failedToSetInspection: "Failed to set inspection.",
  days: "{0} day | {0} days",
};
